'use strict';

var YAxisLines = function YAxisLines(d3Helper) {
  /**
   * @returns {Function}
   * @constructor
   */
  var Lines = function Lines() {
    var params, scales;
    var horizontalLinesValues;
    function calculateLinesData() {
      var linesData;
      var lineShift = 0;
      if (horizontalLinesValues) {
        linesData = horizontalLinesValues;
      } else if (scales.yScale.ticks) {
        linesData = scales.yScale.ticks(params.yNumberOfTicks);
      } else {
        linesData = scales.yScale.domain();
        if (linesData.length > 1) {
          var range = scales.yScale.range();
          var rangeBand = scales.yScale.rangeBand();
          lineShift = (range[1] - range[0] - rangeBand) / 2 + rangeBand;
        }
      }
      return {
        data: linesData,
        shift: lineShift
      };
    }

    /**
     * Constructs helper horizontal lines
     * @param container
     */
    function createHorizontalLines(container) {
      var gElem = d3Helper.createGroupElement(container, 'y-axis-lines');
      var rangeExtent;
      if (scales.xScale.linesRange) {
        rangeExtent = scales.xScale.linesRange();
      } else {
        rangeExtent = scales.xScale.rangeExtent ? scales.xScale.rangeExtent() : scales.xScale.range();
      }
      var linesData = calculateLinesData();
      gElem.selectAll('line').remove();
      var lines = gElem.selectAll('line').data(linesData.data);
      lines.enter().append('line').attr('class', function (d) {
        return 'y-axis-line-' + d;
      });
      lines.exit().remove();
      function calculateYPosition(value) {
        return scales.yScale(value) + linesData.shift;
      }
      gElem.selectAll('line').attr(d3Helper.roundCoordinates({
        'x1': rangeExtent[0],
        'y1': calculateYPosition,
        'x2': rangeExtent[1],
        'y2': calculateYPosition
      }, ['x1', 'y1', 'x2', 'y2']));
    }

    /**
     *
     * @param container
     */
    function yAxis(container) {
      var axesGroup = d3Helper.createGroupElement(container, 'group-axes');
      axesGroup.call(createHorizontalLines);
    }
    yAxis.withHorizontalLinesValues = function (values) {
      horizontalLinesValues = values;
      return yAxis;
    };
    yAxis.params = function (value) {
      params = value;
      return yAxis;
    };
    yAxis.scales = function (value) {
      scales = value;
      return yAxis;
    };
    return yAxis;
  };
  return Lines;
};
YAxisLines.$inject = ['d3Helper'];
module.exports = YAxisLines;